import { render } from "./PaymentCompleted.vue?vue&type=template&id=0aaca536"
import script from "./PaymentCompleted.vue?vue&type=script&lang=js"
export * from "./PaymentCompleted.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__